(function() {
	'use strict';

	angular.module('quantixApp').controller('NavbarController',
			NavbarController);

	NavbarController.$inject = [ '$scope', '$stateParams', '$state', 'Auth', 'Principal',
			'industryService', 'masterService', 'ProfileService','GenericService',
			 'AlertService',
			'AuthTrackerProvider', '$rootScope', '$sessionStorage', '$timeout',
			'$location', '$anchorScroll', '$controller', '$interval',
			'CompanyIndAlertService','CompanyReportService', 'AuthKeycloak', 'PortfolioService' ];

	function NavbarController($scope, $stateParams,$state, Auth, Principal, industryService,
			masterService, ProfileService, GenericService,
			AlertService, AuthTrackerProvider, $rootScope, $sessionStorage,
			$timeout, $location, $anchorScroll, $controller, $interval,
			CompanyIndAlertService,CompanyReportService, AuthKeycloak, PortfolioService
			) {
		$rootScope.duplicatehideflag = false;
		$scope.isGenericFeedPortfolioEnabled = false;
		$scope.hasAdminRole = false;

		if ($sessionStorage.sessionConfrimation != undefined
				&& $sessionStorage.sessionConfrimation == 'duplicateLogins') {
			$timeout(function() {
				$rootScope.duplicatehideflag = true;
			}, 10);
		} else {
			$timeout(function() {
				$rootScope.duplicatehideflag = false;
			}, 10);
		}

		$scope.isNavbarCollapsed = false;
		$scope.isAuthenticated = Principal.isAuthenticated;
		// alert($scope.isAuthenticated);
		$scope.account = null;
		$scope.industry = false;
		$scope.company = false;
		$scope.notificationDetailsList = [];
		ProfileService.getProfileInfo().then(function(response) {
			$scope.inProduction = response.inProduction;
			$scope.swaggerEnabled = response.swaggerEnabled;
		});
        $scope.checkFeedPortfolioScreenEnable = function() {
            PortfolioService.getIsGenericFeedPortfolioEnabled()
            .then(function(data) {
                $scope.isGenericFeedPortfolioEnabled=data
              });
            $scope.hasAdminRole = AuthKeycloak.authz.hasRealmRole('ROLE_ADMIN')
        }
        $scope.checkFeedPortfolioScreenEnable();
		$rootScope.lockimage = $sessionStorage.logImage;
		$scope.$state = $state;
		$scope.flagViewAll = true;
		$("#indexPageContainer").addClass("page-container");

		$scope.login = function() {
			$scope.collapseNavbar();
		}

		Principal.identity().then(function(account) {
			$scope.account = account;
			$scope.fullName="";
			if(account.firstName!=null){
				$scope.fullName+=account.firstName
			}
			if( account.lastName!=null){
				$scope.fullName+=" "+account.lastName;
			}

		});

		$scope.logout = function() {
			$scope.collapseNavbar();
			AuthTrackerProvider.logout();
			// AuthTrackerProvider.cancelCurrentSession().then(function(response)
			// {
			// var sucussRes = response.data[0];
			// if (sucussRes == 'Success') {
			// Auth.logout();
			// $state.go('login');
			// } else {
			// Auth.logout();
			// $state.go('login');
			// }
			// });
		}

		$scope.collapseNavbar = function() {
			$scope.isNavbarCollapsed = true;
		}

		// get filter list of compnaies
		$scope.companyCode = "";

		// get filter list of compnaies

		$scope.ifHasCompanyRepAdminRole = function() {
			return AuthKeycloak.authz.hasRealmRole('ROLE_COMPANY_REPORT_ADMIN');
		}

		$scope.ifHasCompanyRepExtAdminRole = function() {
			return AuthKeycloak.authz.hasRealmRole('ROLE_COMPANY_REPORT_PRODUCT_ADMIN');
		}

		$scope.selectCompany = function(companyObj, section) {
			// alert("here ");
			$scope.selected = true;
			$scope.industryobjtemp = {};
			$scope.industryobjtemp = companyObj;
			$scope.companyCode = companyObj.id;
			$scope.companyName = companyObj.label;
			$scope.type = companyObj.type;
			$scope.id = companyObj.id;
			$scope.flag = companyObj.flag;
			// alert($scope.companyCode +" "+$scope.type+ " "+section);
			if ($scope.type == 'INDUSTRY') {

				$scope.companyCode = companyObj.id;
				$scope.compObj = companyObj;

				$scope.industryObj = {
					"id" : companyObj.id,
					"label" : companyObj.label
				};

				$state
					.go(
							"industryProfileDetails",
							{
								objtodisplay : $scope.outputParameters,
								industryId : $scope.companyCode,
								industryName : $scope.compObj.label,
								industryAlertFlag : $scope.compObj.industryAlertFlag,
								label : $scope.industryobjtemp.label,
								compObj: $scope.compObj
							});

			} else if ($scope.type == 'COMPANY') {
				if ($scope.id != "") {
					if (section == 'financial') {
						$state.go('financialDetails', {

							companyName : $scope.companyName,
							companyCode : $scope.id,
							IsSearch : 'Y',
						});
					} else {
						if ($scope.flag == 'SME' || $scope.flag == 'NSIC') {
							$state.go('smeDetails', {
								'companyCode' : $scope.id,
								flag : $scope.flag
							});
						} else {
							$state.go("companyDetails", {
								sectionId : $scope.sectionId,
								companyCodeToview : $scope.id,
								companyCode : $scope.id,
								flag : $scope.flag,
								companyName : $scope.companyName,
							});

						}
					}

				} else {
					$scope.error = true;
					$scope.errorMessages = "Please select a company from the suggested list.";
				}
			} else if ($scope.type == 'Port') {
				if ($scope.id != "") {
					$state.go('portfolioLanding', {
						'portfolioId' : companyObj.id,
						'portfolioName' : companyObj.label,
						'portfolioDateTime':companyObj.lastmodifieddate
					});
				} else {
					$scope.error = true;
					$scope.errorMessages = "Please select a company from the suggested list.";
				}
			}
		}

		$scope.searchFilterMaster = function(typedthings) {

			$scope.selected = true;
			$scope.companyCode = "";

			if (typedthings == "cleanData") {
				$scope.companies = null;

			} else {
				masterService
						.getListName(typedthings)
						.then(
								function(response) {
									$scope.searchList = response.data;

									$scope.searchList
											.map(function(row) {
												if (row.type == 'CIN' || 'COMPANY' || 'PAN') {
													row.htmlstr = "";
													row.htmlstr = ' <span> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><defs> <style>.cls-1{fill: none; stroke: #bbb; stroke-width: 2px;}.cls-1:hover{stroke: #fff;}.cls-2{fill: #bbb;}.cls-2:hover{fill: #bbb;}</style></defs><rect x="3" y="1" width="18" height="22"/><rect x="8" y="6" width="1" height="1"/><rect id="Rectangle_2_copy" data-name="Rectangle 2 copy" x="15" y="6" width="1" height="1"/><rect id="Rectangle_2_copy_2" data-name="Rectangle 2 copy 2" x="8" y="14" width="1" height="1"/><rect id="Rectangle_2_copy_2-2" data-name="Rectangle 2 copy 2" x="15" y="14" width="1" height="1"/> </svg> '
															+ row.label
															+ ' </span> ';
													;
													if (row.listingStatus == "Y"
															&& row.companySubType == "Financial") {
														row.htmlstr = row.htmlstr
																+ ' <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-briefcase  header_icon_svg pull-right"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg> ';
													}

												}
												if (row.type == 'INDUSTRY') {
													row.htmlstr = ' <span>  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-triangle header_icon_svg"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path></svg> </i>'
															+ row.label
															+ ' </span> ';
												}
												if (row.type == 'Port') {
													row.htmlstr = ' <span> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-briefcase  header_icon_svg pull-right"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg> '
															+ row.label
															+ ' </span> ';
												}

											});

									AlertService.closeAlert();

									if ($scope.searchList.length == 0) {
										$scope.error = true;
										$scope.showError = true;
										$scope.errorMessages = "No records match the text entered, please change your selection.";
										AlertService
												.error("No records match the text entered, please change your selection.");
										$timeout(function() {

											$scope.error = false;
											$scope.showError = false;
											$scope.errorMessages = "";

										}, 2000);
									}

								}, function(errordata) {
									console.log("Error in service"+errordata);
								});
			}

		}

		$scope.compareIndustry = function(type) {
			$scope.result = angular.equals(type, 'Industry');
			return angular.equals('Industry', 'Industry');
		};

		$scope.compareCompany = function(type) {
			$scope.result = angular.equals(type, 'Company');
			return angular.equals(type, 'Company');
		};

		$scope.totalCount = 0;

		// store the interval promise in this variable
		var promise;

		// starts the interval
		$scope.start = function() {
			// stops any running interval to avoid two intervals running at the
			// same time
			$scope.stop();

			// store the interval promise
			promise = $interval(function() {
				$scope.notificationDetails();
				$scope.getNotifications();
			}, 480000);
		};

		// stops the interval
		$scope.stop = function() {
			$interval.cancel(promise);
		};

		// starting the interval by default
		$scope.start();

		// stops the interval when the scope is destroyed,
		$scope.$on('$destroy', function() {
			$scope.stop();
		});

		$scope.notificationDetails = function() {

			CompanyIndAlertService
					.getNotificationDetails()
					.then(
							function(data) {
								if (data != null || data != undefined) {

									$scope.totalCount = data.notificationCount;
									$scope.notificationDetailsList = data.notificationList;
									$scope.notificationNotSeenCount = data.notificationNotSeenCountLastSevenDay;
								}

							}, function(errordata) {

							});
		}

		$scope.goToAlertLevelPlatform = function(notification) {

			if (notification != undefined
					&& notification.notificationType != ''
					&& notification.notificationSentFlag != '' && notification.notificationSentFlag == 'N' && notification.notificationType!='ESG_Alert') {

				CompanyIndAlertService
						.getNotificationTypePlatform(notification)
						.then(function(data) {
							if (data.length != 0) {
								var obj = data[0];
								if (obj.type == 'COMPANY' && obj.id != "") {

									if (obj.sectionType == 'rating') {
										$state.go('ratingInformation', {
											'companyCode' : obj.id,
											'companyName' : obj.label
										});
										$anchorScroll();
									} else {
										$state.go("companyDetails", {
											sectionId : obj.section,
											companyCodeToview : obj.id,
											companyCode : obj.id,
											companyName : obj.label
										});

									}

								} else if (obj.id != "") {
									$scope.selectCompany(obj, null);
								}

								$scope.notificationDetails();
							}

						}, function(errordata) {
						});

			}else if( notification.notificationType=='ESG_Alert'){
				CompanyIndAlertService.userPlatformNotificationSavedSentStatus(
					notification).then(function(data) {

						window.location.href='/esg/';


			}, function(errordata) {
				vm.entityResponse = errordata.data;
				$scope.errorMessage = vm.entityResponse.message;
				$scope.error = true;
				$timeout(function() {

					$scope.error = false;
					$scope.errorMessage = "";

				}, 2000);
			});
			}



			$rootScope.$on("callTopFiveNotification", function() {
				$scope.notificationDetails();
			});
		}

		$scope.getNotifications = function() {
			$timeout(function() {
				$rootScope.$emit("callUserLastSevenDaysNotifications");
			}, 100)
		}

		$rootScope.$on("callTopFiveNotification", function() {
			$scope.notificationDetails();
		});

		$scope.getClass = function(notificationType) {

			switch (notificationType) {
			case "COMPANY":
				return "fa fa-building-o";
				break;
			case "INDUSTRY":
				return "fa fa-industry";
				break;
			case "PORTFOLIO":
				return "fa fa-building-o";
				break;

			}

		}



	$scope.IncrUserAddCompInfoAdmin=function(){

		var  enable=false;
		GenericService.getUserModuleAccessData().then(function (result) {
		if (
			 result['COMPANY_INFO_REPORT_LITE_PLUS']  ||
			 result['COMPANY_INFO_REPORT_ADVANCED_PLUS'] ||
		 	 result['COMPANY_INFO_REPORT_COMPREHENSIVE_PLUS'] ||
		 	 result['COMPANY_INFO_REPORT1']||
		 	 result['COMPANY_INFO_REPORT2'] ||
		 	 result['COMPANY_INFO_REPORT3']
		 )
		{
			enable = true;
		}

		// if(enable){
		// 	CompanyReportService
		// 	.insertIncrementalUser()
		// 	.then(
		// 			function(data) {
		// 			 //alert(JSON.stringify(data));

		// 			}, function(errordata) {
		// 				//alert(JSON.stringify(errordata));
		// 			});
 		// }
		 if(enable){
			GenericService
			.insertIncrementalUser()
			.then(
					function(data) {
					 //alert(JSON.stringify(data));

					}, function(errordata) {
						//alert(JSON.stringify(errordata));
					});
 		}

	});


		}

		$scope.selectCompanyNew = function(companyObj, section) {
			masterService
						.getListCompIndCode(companyObj.id)

						.then(
								function(response) {
									//need to add validation
									// $scope.searchList = response.data;
									// $scope.selectCompany
									if(null != response.data && response.data.length>0)
									{
										var data = response.data[0];
										$scope.selectCompany(data, data.section);
									}



								}, function(errordata) {
									console.log("Error in service"+errordata);
								});

		}


		$scope.notificationDetails();
		$scope.IncrUserAddCompInfoAdmin();


	}

})();

/*
 * Setup Layout Part - Theme Panel
 * angular.module('quantixApp').controller('ThemePanelController',
 * ThemePanelController); ThemePanelController.$inject = [ '$scope' ]; function
 * ThemePanelController($scope) {
 *
 * $scope.css = 'color-default'; $scope.themeArr = [ { name : 'default', classU :
 * 'color-default' }, { name : 'darkblue', classU : 'color-darkblue' }, { name :
 * 'blue', classU : 'color-blue' }, { name : 'grey', classU : 'color-grey' }, {
 * name : 'light', classU : 'color-light' } ]; $scope.value = "fluid";
 * $scope.layout = [ { 'val' : 'fluid' }, { 'val' : 'boxed' } ]; $scope.header =
 * "fixed"; $scope.headerVal = [ { 'val' : 'fixed' }, { 'val' : 'default' } ];
 *
 * $scope.$on('$includeContentLoaded', function() { Demo.init(); // init theme
 * panel handleSidebarAndContentHeight();
 *
 * }); }
 */

// Set proper height for sidebar and content. The content and sidebar height
// must be synced always.

function handleSidebarAndContentHeight() {
	var content = $('.page-content');
	var sidebar = $('.page-sidebar');
	var body = $('body');
	var height;

	if (body.hasClass("page-footer-fixed") === true
			&& body.hasClass("page-sidebar-fixed1") === false) {
		var available_height = App.getViewPort().height
				- $('.page-footer').outerHeight()
				- $('.page-header').outerHeight();
		if (content.height() < available_height) {
			content.attr('style', 'min-height:' + available_height + 'px');
		}
	} else {
		if (body.hasClass('page-sidebar-fixed1')) {
			height = _calculateFixedSidebarViewportHeight();
			if (body.hasClass('page-footer-fixed') === false) {
				height = height - ($('.page-footer').outerHeight() + 60);
			}
		} else {
			var headerHeight = $('.page-header').outerHeight();
			var footerHeight = $('.page-footer').outerHeight();

			if (App.getViewPort().width < resBreakpointMd) {
				height = App.getViewPort().height - headerHeight - footerHeight;
			} else {
				height = sidebar.height() + 20;
			}

			if ((height + headerHeight + footerHeight) <= App.getViewPort().height) {
				height = App.getViewPort().height - headerHeight - footerHeight;
			}
		}
		content.attr('style', 'min-height:' + height + 'px');
	}
};

// Helper function to calculate sidebar height for fixed sidebar layout.
var _calculateFixedSidebarViewportHeight = function() {
	var sidebarHeight = App.getViewPort().height
			- $('.page-header').outerHeight(true);
	if ($('body').hasClass("page-footer-fixed")) {
		sidebarHeight = sidebarHeight - $('.page-footer').outerHeight();
	}

	return sidebarHeight;
};
